/**
 * ek-atc-note
 *
 * The note directly under the add to cart button ("1 free card + free
 * shipping") is resolved server side from the Form block `atc_note_map`, so it
 * is already correct for whichever variant the section was rendered with.
 *
 * On a variant change the theme only replaces `product-variant-select` and the
 * context menu stock, so anything else in the buy box has to pick the new
 * markup out of the fetched section HTML itself. This mirrors
 * `product-usps.js` exactly, which does the same for the USP list.
 */
(() => {
  if (customElements.get('ek-atc-note')) return;

  class EkAtcNote extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;

      if (!this.productId || !this.sectionId) return;
      if (typeof subscribe !== 'function') return;

      this.unsubscribe = subscribe(`variant:changed:${this.productId}:${this.sectionId}`, ({ html }) => {
        const next = html?.querySelector('ek-atc-note');
        if (!next) return;

        this.replaceWith(next.cloneNode(true));
      });
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }
  }

  customElements.define('ek-atc-note', EkAtcNote);
})();
